module.exports = "/packs/010-2a9ce732d95f25ff6dbbd826cba45fda.jpg";